/*
 *
 * Virtual Market
 * products-api - Servicios
 *
 * RYNDEM 2017
 *
 */

/* Core Imports */
import axios from 'axios';
import { API_URL } from './config';

/* Dev Tools */
import { DEBUG } from 'common-protocols';
const OBJECT_ID = 'question-api';

/*********************** Obtener los productos por departamento ***********************/
export function fetchProductsByMarket(token, idMarket, idPais) {
  DEBUG && console.log(OBJECT_ID + "@fetchProductsByMarket: ");

    idPais = idPais ? idPais : 1;

  let requestUrl = `${API_URL}/productos/mercado/${idMarket}/${idPais}`;
  DEBUG && console.log(OBJECT_ID  + "@fetchProductsByMarket: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "get",
    headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Obtener los productos por departamento ***********************/
export function fetchProductsByMarketImages(token, idMarket) {
  DEBUG && console.log(OBJECT_ID + "@fetchProductsByMarketImages: ");

  let requestUrl = `${API_URL}/productos/imagenes/${idMarket}`;
  DEBUG && console.log(OBJECT_ID  + "@fetchProductsByMarketImages: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "get",
    headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Finalizar compra ***********************/
export function  finishPurchase(token, term) {
  DEBUG && console.log(OBJECT_ID + "@finishPurchase: ");

  let requestUrl = `${API_URL}/compras`;
  DEBUG && console.log(OBJECT_ID  + "@finishPurchase: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** PDF -> Resumen de compra ***********************/
export function  getResultsPDF(token, term) {
  DEBUG && console.log(OBJECT_ID + "@getResultsPDF: ");

  let requestUrl = `${API_URL}/resultadosPDF`;
  DEBUG && console.log(OBJECT_ID  + "@getResultsPDF: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}



// WEBPACK FOOTER //
// ./src/services/products-api.js